module.exports = __webpack_public_path__ + "static/media/photo-1.ca43587f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/dukes-park-renovation/photo-1.jpg
// module id = 159
// module chunks = 0